import { Suspense } from 'react';
import { Outlet } from 'react-router';

import LayoutErrorBoundary from './LayoutErrorBoundary';
import LayoutLoader from './LayoutLoader';

import css from './Layout.module.css';

export default function LayoutOutlet({
  children,
  fallback,
}: {
  children?: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  return (
    <main className={css.main}>
      <div className={css.container}>
        <LayoutErrorBoundary>
          <Suspense fallback={fallback || <LayoutLoader />}>
            {children}
            <Outlet />
          </Suspense>
        </LayoutErrorBoundary>
      </div>
    </main>
  );
}
